import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { IItemWishList } from 'src/app/shared/interfaces/custom-item-wish-list';
import { WishList } from 'src/app/utils/functions/wishList';
import { Subscription } from 'rxjs';
import { NotifictChangeListService } from '../../services/notifict-change-list.service';

@Component({
  selector: 'app-custom-wish-list',
  templateUrl: './custom-wish-list.component.html'
})
export class CustomWishListComponent implements OnInit, OnDestroy{

  listItems: IItemWishList[] = [];
  @Output() listChanges = new EventEmitter<boolean>();

  private notificaction?: Subscription;
  constructor(
    private wishList: WishList,
    private notificChangeListService: NotifictChangeListService
  ){

  }
  ngOnDestroy(): void {
    if(this.notificaction){
      this.notificaction.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.listItems = this.wishList.getList();
    this.notificChangeListService.updateNotifications$.subscribe(()=> {
      this.changeOfList();
    })

  }

  changeOfList(){
    this.listItems = this.wishList.getList();
    this.listChanges.emit(true);
  }
}
